import { Box, Flex, Text } from "@theme-ui/components"
import { useResponsiveValue } from "@theme-ui/match-media"
import { graphql, Link } from "gatsby"
import { kebabCase } from "lodash"
import React, { useContext, useEffect, useState } from "react"

import { InterfaceContext } from "../context/interface"

import FeaturedCaseTile from "./featured-case-tile"
import Footer from "./footer"
import Layout from "./layout"
import SEO from "./seo"

const FeaturedCases = ({
  nav,
  dropup,
  subNav,
  footerNav,
  isIndex,
  aboveContent,
  caseCategories,
  caseKey,
  cases,
  data,
  location,
  pageContext,
}) => {
  let { featured, currentCase } = data
  const { hoverCase, isGridView, setHoverCase, setGridView } = useContext(InterfaceContext)

  // When caseKey changes, remove the hoverCase
  useEffect(() => {
    setHoverCase(null)
  }, [caseKey])

  const responsiveGridView = useResponsiveValue([true, isGridView])

  const [lang] = pageContext.locale.split("-")
  let prefix = "/"
  if (lang !== "en") {
    prefix = `/${lang}/`
  }

  const sortedAdditional = caseCategories
    .filter((c) => c !== "Video")
    .sort((a, b) => a.localeCompare(b))
    .map((a) => ({
      key: a,
      label: a === "Stills" ? "Imagery" : a,
    }))
  const cleanedKeys = [
    {
      key: "Video",
      label: "Film",
    },
    ...sortedAdditional,
  ]

  return (
    <Layout
      nav={nav}
      dropup={dropup}
      prefix={prefix}
      subNav={subNav}
      isFeatured
      featuredCases={{
        ...data.featured,
        cases,
      }}
      shouldShowNav
      location={location}
      locale={pageContext.locale}
    >
      <SEO
        locale={pageContext.locale}
        canonicals={pageContext.canonicals}
        title={featured.name}
      />
      <Flex
        sx={{
          flexDirection: "column",
        }}
      >
        {isIndex && aboveContent && !hoverCase &&(
          <Flex
            sx={{
              display: responsiveGridView ? "none !important" : "flex",
              justifyContent: "center",
              minHeight: "100vh",
              padding: "200px",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                color: "darkest",
                fontSize: "25px",
                fontWeight: 300,
                fontFamily: "pragmatica-extended",
                maxWidth: "900px",
                width: !isGridView ? "767px" : "100%",
              }}
              className="rte rte-h1-inline"
              dangerouslySetInnerHTML={{ __html: aboveContent }}
            />
          </Flex>
        )}
        <Flex
          sx={{
            justifyContent: responsiveGridView ? "start" : "center",
            minHeight: "100vh",
            padding: '0',
            flexDirection: "column",
          }}
        >
            <Flex
              sx={{ display: ["block", "none"], alignItems: "center", justifyContent: "space-between" }}
            >
              {cleanedKeys.map((c) => (
                <Flex
                  key={c.key}
                  px={4}
                  sx={{
                    flex: 1,
                    borderTop:
                      caseKey === c.key ? "1px solid black" : undefined,
                    borderColor: "darkest",
                    fontFamily: "pragmatica-extended, sans-serif",
                    fontWeight: caseKey === c.key ? 600 : 200,
                    textTransform: "uppercase",
                    alignItems: "center",
                    color: "darkest",
                    height: "80px",
                    justifyContent: "center",
                    ":first-of-type": {
                      justifyContent: "flex-start",
                    },
                    ":last-of-type": {
                      justifyContent: "flex-end",
                    },
                  }}
                >
                  <Link
                    style={{ textDecoration: "none" }}
                    to={`/${data.featured.slug}${
                      c.key !== "Video" ? `/${kebabCase(c.key)}` : ""
                    }/`}
                  >
                    {c.label}
                  </Link>
                </Flex>
              ))}
            </Flex>
          <Box
            sx={{
              display: responsiveGridView ? "grid" : "flex",
              gridTemplateColumns: ["1fr", "1fr", "1fr 1fr"],
              gridTemplateRows: "1fr",
              gridRowGap: "3px",
              gridColumnGap: "3px",
              flexDirection: "column",
              alignItems: !responsiveGridView && "center",
              width: "100%",
            }}
          >
            {responsiveGridView ? (
              false ? (
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                  }}
                />
              ) : (
                cases.map((c) => (
                  <FeaturedCaseTile
                    active
                    isGridView={responsiveGridView}
                    activeCases={caseKey}
                    hoverCase={c}
                    featuredCase={c}
                    prefix={prefix}
                  />
                ))
              )
            ) : (
              <FeaturedCaseTile
                active
                index={cases.findIndex((c) =>
                  hoverCase
                    ? c.contentful_id === hoverCase
                    : c.slug === currentCase.slug
                )}
                caseCount={cases.length}
                hoverCase={cases.find((c) => c.contentful_id === hoverCase)}
                isGridView={responsiveGridView}
                activeCases={caseKey}
                featuredCase={currentCase}
                prefix={prefix}
              />
            )}
          </Box>
          <Footer px={[3, "40px"]} sx={{display: ["flex", "none"]}} nav={footerNav} prefix={prefix} />
        </Flex>
      </Flex>
    </Layout>
  )
}

export default FeaturedCases